import { useState, useEffect } from 'react'
import { useRetailerId, usePartnerId } from 'utils/routing/params.hooks'
import { fetchDepartments } from 'legacy/common/utils/catalog/departments/departments.api'
import {
  dataFetchingLoading,
  type DataFetchingState,
  dataFetchingSuccess,
  dataFetchingError,
} from 'legacy/common/utils/data-fetching/dataFetching.types'
import { type SearchApiFetchDepartmentsResponse } from 'legacy/common/utils/catalog/departments/departments.types'

const initialApiState = dataFetchingLoading<SearchApiFetchDepartmentsResponse>()

export const useDepartments = () => {
  const partnerId = usePartnerId()
  const retailerId = useRetailerId()

  const [apiState, setApiState] =
    useState<DataFetchingState<SearchApiFetchDepartmentsResponse>>(initialApiState)

  useEffect(() => {
    fetchDepartments({ partnerId, retailerId })
      .then(result => setApiState(dataFetchingSuccess(result)))
      .catch((err?: Error) => setApiState(dataFetchingError(err)))
  }, [partnerId, retailerId])

  return {
    departments: (apiState.data && apiState.data.data) || [],
    departmentsLoading: apiState.loading,
    error: apiState.error,
  }
}
